// Sentry frontend scaffolding (P2-2). No-op when REACT_APP_SENTRY_DSN
// is unset — same posture as backend/lib/sentry.js. Keeps the SDK
// wired but doesn't ship traffic until the operator opts in.

let initialised = false;

export function initSentry() {
  if (initialised) return;
  initialised = true;
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  // Lazy require so the SDK isn't bundled into the main chunk when
  // it's disabled. CRA's webpack pulls it in only when the import()
  // resolves.
  import('@sentry/react').then((Sentry) => {
    Sentry.init({
      dsn,
      environment: process.env.NODE_ENV || 'development',
      tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_SAMPLE || '0.1'),
      // Don't capture form values or DOM input contents — privacy
      // posture matches the backend's sendDefaultPii=false.
      sendDefaultPii: false,
    });
    // eslint-disable-next-line no-console
    console.log('[sentry] frontend enabled');
  }).catch(() => {/* SDK missing — fail silent */});
}

// Manual capture entry point. Components or hooks that want to
// surface a non-fatal error can call this; no-op when disabled.
export function captureError(err, ctx = {}) {
  if (!initialised || !process.env.REACT_APP_SENTRY_DSN) return;
  import('@sentry/react').then((Sentry) => {
    Sentry.withScope((scope) => {
      for (const [k, v] of Object.entries(ctx)) scope.setExtra(k, v);
      Sentry.captureException(err);
    });
  }).catch(() => {});
}
